export default {
  "content": "<g stroke=\"#3F4450\" stroke-width=\"2\" stroke-linejoin=\"round\"><path d=\"M9.947 18.015h10.658M4.974 28.103V.721H26.29v26.662c0 .764-.3 1.497-.833 2.038a2.822 2.822 0 01-2.01.844H2.842M9.947 9.368h9.948m-9.948 4.323h12.08m-12.08 8.647h4.974\"/><path d=\"M.71 25.941h4.264v2.162a2.18 2.18 0 01-.625 1.529c-.4.405-.942.633-1.507.633a2.117 2.117 0 01-1.507-.633 2.177 2.177 0 01-.624-1.529v-2.162zM4.974 3.617h21.315\"/></g>",
  "attrs": {
    "width": "27",
    "height": "31",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};